import { GetContractCDRTotalQuery } from '../interfaces/contract-cdr-total';

export function validateQueryParams(query: GetContractCDRTotalQuery): Required<GetContractCDRTotalQuery> {
  if (!query.id) throw new Error('ContractIdRequired');
  return {
    id: query.id,
    duration: query?.duration ?? 'lastMonth',
  };
}
